type Callback = (...args: any[]) => void;
export function debounce(cb: Callback, wait = 20): Callback {
  let timer: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => cb(...args), wait);
  };
}
